import React from 'react';
import './App.css';
import Scene from './components/Scene';
import Board from './components/Board';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faMugHot, faLemon, faFlask } from '@fortawesome/free-solid-svg-icons';

library.add(fas, faMugHot, faLemon, faFlask)

/*
Improvements to implement before adding to portfolio:
[ ] change button colors on hover and click
[ ] improve about page
[ ] clean up css and merge classes
*/

function App() {

  const [inGame, setInGame] = React.useState(false)

  return (
    <div className="App">
      {inGame ? <Board setInGame={setInGame}/> : <Scene setInGame={setInGame}/>}
    </div>
  );
}

export default App;
